import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import ChangeLoginForm from '../forms/ChangeLoginForm'
import globals from '../globals'

class ChangeLogin extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            profile: {}
        }
    }

    render () {
        return (
            <div className='invoices module'>
                <Heading title='Change My Exetel password' />
                <ModuleWithLoader isLoaded className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>You can change your My Exetel password here. Once you have hit the “Update details” button, we’ll send you an email confirming that your password has been changed. And remember, always keep your password safe.</p>
                        </div>
                        <div className='col-12 col-md-8 offset-md-2'>
                            <ChangeLoginForm
                                fields={this.state.profile}
                                isVerified={this.props.isVerified}
                                handleVerificationSuccess={this.props.handleVerificationSuccess}
                                handleSuccess={() => globals.pushEvent('ChangePasswordSubmit')}
                            />
                            <div className='my-3'>
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default ChangeLogin



// WEBPACK FOOTER //
// ./resources/js/modules/ChangeLogin.js